export default function VenueCardSkeleton() {
  return (
    <div className="bg-white border border-[#d9d9d9] md:border-[#ededed] rounded-[20px] md:rounded-[18px] p-4 md:p-3 w-full max-w-[402px] md:shadow-[0px_1px_5.3px_0px_rgba(0,0,0,0.25)] overflow-hidden">
      {/* ========== MOBILE SKELETON ========== */}
      <div className="md:hidden">
        {/* Main Content */}
        <div className="flex gap-3">
          {/* Left: Thumbnail Image Skeleton */}
          <div className="flex-shrink-0 w-[85px] h-[81px] rounded-[10px] bg-gray-200 " />

          {/* Right: Info Section */}
          <div className="flex-1 min-w-0">
            {/* Title Row */}
            <div className="flex items-center gap-1.5 mb-2">
              <div className="size-6 bg-gray-200 rounded-full " />
              <div className="h-4 w-3/4 bg-gray-200 rounded " />
            </div>

            {/* Badges Row */}
            <div className="flex items-center gap-2 flex-wrap">
              <div className="h-5 w-20 bg-gray-200 rounded-[10.87px] " />
              <div className="h-5 w-28 bg-gray-200 rounded-[10.87px] " />
            </div>

            {/* Distance Skeleton */}
            <div className="flex items-center gap-1.5 mt-2">
              <div className="size-3 bg-gray-200 rounded-full " />
              <div className="h-3 w-12 bg-gray-200 rounded " />
            </div>
          </div>
        </div>

        {/* Description Section */}
        <div className="flex items-start gap-2 mt-3">
          <div className="size-4 bg-gray-200 rounded mt-0.5 " />
          <div className="flex-1 space-y-1.5">
            <div className="h-3 w-full bg-gray-200 rounded " />
            <div className="h-3 w-4/5 bg-gray-200 rounded " />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-2 mt-4">
          <div className="h-[34px] w-24 bg-gray-200 rounded-lg " />
          <div className="h-[34px] w-20 bg-[#20b038] rounded-lg ml-auto" />
        </div>
      </div>

      {/* ========== DESKTOP SKELETON ========== */}
      <div className="hidden md:block">
        {/* Photo Carousel Skeleton */}
        <div className="rounded-[12px] overflow-hidden mb-3">
          <div className="w-full h-[240px] bg-gray-200 " />
        </div>

        {/* Content Section */}
        <div className="px-1">
          {/* Title Row */}
          <div className="flex items-center gap-1.5 mb-1.5">
            <div className="size-5 bg-gray-200 rounded-full " />
            <div className="h-5 w-3/4 bg-gray-200 rounded " />
          </div>

          {/* Badges Row */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-1.5">
              <div className="h-5 w-20 bg-gray-200 rounded-full " />
              <div className="h-5 w-24 bg-gray-200 rounded-full " />
            </div>
            <div className="h-4 w-12 bg-gray-200 rounded " />
          </div>

          {/* Description Section */}
          <div className="flex items-start gap-2 mb-3">
            <div className="size-4 bg-gray-200 rounded mt-0.5 " />
            <div className="flex-1 space-y-1.5">
              <div className="h-3 w-full bg-gray-200 rounded " />
              <div className="h-3 w-4/5 bg-gray-200 rounded " />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-2">
            <div className="h-[36px] w-24 bg-gray-200 rounded-[10px] " />
            <div className="h-[36px] w-24 bg-gray-200 rounded-[10px] " />
            <div className="h-[36px] flex-1 bg-[#20b038] rounded-[10px] ml-auto" />
          </div>
        </div>
      </div>
    </div>
  );
}
